import { render } from "./TPPopLayout.vue?vue&type=template&id=4c9f0a42&scoped=true&ts=true"
import script from "./TPPopLayout.vue?vue&type=script&lang=ts"
export * from "./TPPopLayout.vue?vue&type=script&lang=ts"

import "./TPPopLayout.vue?vue&type=style&index=0&id=4c9f0a42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9f0a42"]])

export default __exports__